import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApplicationConfigService {
  private baseUrl = environment.baseUrl;
  // private port = environment.port;
  
  getEndpointFor(api: string, prefix = '/api/', version = 'v1/'): string {
    return `${this.baseUrl}${prefix}${version}${api}`;
  }

  getRequestUrlFor(api: string, version = 'v1'): string {
    return `/api/${version}/${api}`;
  }
}
